type CatalogVersionRecord = {
  id?: number;
  used?: number;
  active?: boolean;
};

type CatalogSkillEntry = {
  versions?: Record<string, CatalogVersionRecord>;
};

export const getCatalogSkillVersions = (course: CatalogSkillEntry = {}) => Object.entries(course.versions || {})
  .map(([version, details]) => ({
    version,
    used: details?.used || 0,
    active: !!details?.active,
  }));

export const getActiveVersionCourseId = (courseId: string, course: CatalogSkillEntry = {}) => {
  const activeVersion = getCatalogSkillVersions(course).find(version => version.active);

  if (activeVersion && courseId.endsWith('+')) {
    return `${courseId}${activeVersion.version}`;
  }

  return courseId;
};

/**
 * Company Catalog V2's `available` value is already the remaining balance.
 * Only staged allocations should be subtracted from it; `used` is a separate
 * reporting count and must not be subtracted again.
 */
export const getCatalogRemainingAvailability = (
  available: number | null | undefined,
  stagedAllocations = 0,
) => (available == null ? null : available - stagedAllocations);
